/**
 * live visitor listesini sunucu ile sync olup olmadığını iletir.
 */
import { interval } from "rxjs";
import { map } from "rxjs/operators";
import store from "@/store";
import log2 from "../utils/log2";
import visitor from "../store/modules/visitor";

const log = log2("liveVisitorCountReporter");

export const liveVisitorCountReporter = () => {
    log.info("liveVisitorCountReporter running");
    return interval(30000)
        .pipe(map((x) => visitor.state.liveVisitors.length))
        .subscribe((liveVisitorCount) => {
            store.dispatch("visitor/reportLiveVisitorCount", liveVisitorCount);
        });
};
